import { ButtonProps } from './types';
import { StyledButton, StyledButtonLink, StyledButtonNextLink } from './styles';

export const Button = ({
  className = '',
  href = '',
  label,
  linkout = true,
  onClick,
  square = false,
  variant = 'secondary',
  width,
}: ButtonProps) => {
  const sharedProps = {
    className,
    square,
    variant,
    width,
  };

  if (!href) {
    return (
      <StyledButton
        {...sharedProps}
        onClick={onClick}
      >
        {label}
      </StyledButton>
    );
  }

  if (href && !linkout) {
    return (
      <StyledButtonNextLink
        {...sharedProps}
        href={href}
      >
        {label}
      </StyledButtonNextLink>
    );
  }

  return (
    <StyledButtonLink
      {...sharedProps}
      href={href}
      target="_blank"
    >
      {label}
    </StyledButtonLink>
  );
};
